function checkCountdownStockBox() {
  const $messages = $('.samita_countdown_stock_mes-layout');
  let anyValidAmount = false;

  $messages.each(function (index) {
    const $span = $(this).find('span');
    const amountText = $span.text().trim();
    const amount = parseInt(amountText, 10);
    const $countdownBox = $(this).closest('.samita-countdown');

    console.log(
      'Element', index + 1, '– Wert im <span>:', amountText, '→ interpretiert als:', amount
    );

    if (isNaN(amount) || amount <= 0) {
      console.log('Block wird entfernt – ungültiger oder zu niedriger Bestand:', amountText);
      $countdownBox.remove();
    } else {
      anyValidAmount = true;
      console.log('Block bleibt sichtbar – gültiger Bestand:', amount);
    }
  });

  return anyValidAmount;
}

function removeInvalidTimers() {
  const hasValidStock = checkCountdownStockBox();
  if (!hasValidStock) {
    $('.samita_countdown_timer_container').each(function () {
      console.log('Timer ohne Lagerbestand erkannt – wird entfernt.');
      $(this).remove();
    });
  } else {
    console.log('Gültiger Lagerbestand vorhanden – Timer bleibt.');
  }
}

function observeForSamitaTimers() {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.addedNodes.length > 0) {
        $(mutation.addedNodes).each(function () {
          if ($(this).hasClass('samita_countdown_timer_container') || $(this).find('.samita_countdown_timer_container').length > 0) {
            console.log('Samita-Timer im DOM entdeckt – wird geprüft...');
            removeInvalidTimers();
          }
        });
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  console.log('MutationObserver gestartet – Timer-Überwachung aktiv.');
}

$(document).ready(function () {
  console.log('samira-counter.js geladen – Prüfung wird gestartet.');
  removeInvalidTimers(); // initial
  observeForSamitaTimers(); // dauerhaft
});
